import { render, staticRenderFns } from "./VoiceItemInput.vue?vue&type=template&id=f1210804&scoped=true"
import script from "./VoiceItemInput.vue?vue&type=script&lang=js"
export * from "./VoiceItemInput.vue?vue&type=script&lang=js"
import style0 from "./VoiceItemInput.vue?vue&type=style&index=0&id=f1210804&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1210804",
  null
  
)

export default component.exports